<template>
  <div style="width: 100%;" :class="{english:lang=='EN'}">
    <div class="hidden-xs">
      <div class="address">
        <div class="content">
          <div class="left wow fadeInUp">
            <p>{{$t('contactUs.address')}}</p>
            <span>{{$t('contactUs.tip3')}}</span>
          </div>
          <div class="middle">
            <div class="menu wow fadeInUp">
              <div class="item">
                <div>
                  <img style="width: 7.06rem;height: 7.5rem;margin-top: 0.13rem;"
                       src="../../../assets/img/aboutus/yantai.png">
                </div>
                <p>{{$t('contactUs.city1')}}</p>
                <span>
             {{$t('contactUs.add1')}}
            </span>
              </div>
              <div class="item">
<!--                <div>-->
<!--                  <img style="width: 7.06rem;height: 7.63rem;" src="../../../assets/img/aboutus/yangzhou.png">-->
<!--                </div>-->
<!--                <p>{{$t('aboutUs.city2')}}</p>-->
<!--                <span>-->
<!--              {{$t('aboutUs.add2')}}-->
<!--            </span>-->
              </div>
<!--              <div class="item">-->
<!--                <div>-->
<!--                  <img style="width:14.06rem;height: 6.75rem;margin-top: 0.86rem;"-->
<!--                       src="../../../assets/img/aboutus/xinjiapo.png">-->
<!--                </div>-->
<!--                <p>{{$t('aboutUs.city3')}}</p>-->
<!--                <span>-->
<!--              {{$t('aboutUs.add3')}}-->
<!--            </span>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="visible-xs">
      <div class="address">
        <div class="content">
          <div class="left wow fadeInUp">
            <p>{{$t('contactUs.address')}}</p>
            <span>{{$t('contactUs.tip3')}}</span>
          </div>
          <div class="right">
            <div class="menu-ul wow fadeInUp">
              <div class="item">
                <div class="logo">
                  <img src="../../../assets/img/aboutus/yantai.png">
                </div>
                <div class="info">
                  <p>{{$t('contactUs.city1')}}</p>
                  <span>
                  {{$t('contactUs.add1')}}
                </span>
                </div>
              </div>
<!--              <div class="item">-->
<!--                <div class="logo">-->
<!--                  <img src="../../../assets/img/aboutus/yangzhou.png">-->
<!--                </div>-->
<!--                <div class="info">-->
<!--                  <p>{{$t('contactUs.city2')}}</p>-->
<!--                  <span>{{$t('contactUs.add2')}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="logo">-->
<!--                  <img src="../../../assets/img/aboutus/xinjiapo_xs.png">-->
<!--                </div>-->
<!--                <div class="info">-->
<!--                  <p>{{$t('contactUs.city3')}}</p>-->
<!--                  <span>-->
<!--                   {{$t('contactUs.add3')}}-->
<!--                  </span>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {WOW} from 'wowjs'
  import {mapGetters} from 'vuex'

  export default {
    name: 'Address',
    components: {},
    props: {},
    data () {
      return {}
    },
    methods: {},
    mounted () {
      const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: false
      })
      wow.init()
    },
    computed: {
      ...mapGetters(['lang']),
      getComponentName () {
        return 'Address'
      }
    }

  }
</script>

<style lang="scss" scoped>
  .address {
    width: 100%;
    // height: 32.25rem;
    padding:8rem 0;
    display: flex;
    flex-direction: row-reverse;
    background: #f6f6f6;

    .content {
      width: 100%;
      // max-width: 96.25rem;
      max-width: 75rem;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;

      .left {
        width:18.75rem;
        margin-right: 4.5rem;
        p {
          font-size: 2rem;
          // font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: rgba(63, 74, 93, 1);
          line-height: 3.13rem;
          letter-spacing: 0.19rem;
        }

        span {
          font-size: 1rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: rgba(63, 74, 93, 1);
        }
      }

      .right {
        width: 100%;

        .menu {
          width: 100%;
          // max-width: 52.5rem;
          display: flex;
          justify-content: space-between;

          .item {
            width: 16.25rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            p {
              font-size: 1.5rem;
              // font-family: Arial, Source Han Sans CN;
              font-weight: 400;
              color: #333333;
              line-height: 5.25rem;
              margin-bottom: 0;
            }

            span {
              max-width:100%;
              font-size: 0.88rem;
              // font-family: Arial, Source Han Sans CN;
              font-weight: 300;
              color: rgba(102, 102, 102, 1);
              // height: 4rem;
            }
          }
        }
      }
    }
  }

  .visible-xs {
    .address {
      width: 100%;
      // height: 31rem;
      display: flex;
      flex-direction: row-reverse;
      background: #F3F6FB;
      padding:0;
      .content {
        width: 100%;
        max-width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .left {
          width: auto;
          margin-right: 0;
          p {
            font-size: 1.5rem;
            // font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(63, 74, 93, 1);
            line-height:auto;
            letter-spacing: 0.19rem;
            padding-top:2rem;
          }

          span {
            font-size: 0.8rem;
            // font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            color: rgba(63, 74, 93, 1);
          }
        }

        .right {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;

          .menu-ul {
            width: 100%;
            max-width: 90%;

            .item {
              height: auto;
              display: flex;
              justify-content: center;
              align-items: center;
              background: #FFFFFF;
              padding: 1rem 1.5rem;
              margin: 1rem 0;

              .logo {
                width: 4rem;
                height: 4rem;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 5%;

                img {
                  width: 4rem;
                  height: auto;
                }
              }

              .info {
                width: 70%;

                p {
                  font-size: 1rem;
                  // font-family: Arial, Source Han Sans CN;
                  font-weight: 400;
                  color: rgba(63, 74, 93, 1);
                  line-height: 2rem;
                  margin-bottom: 0;
                }

                span {
                  font-size: 0.8rem;
                  font-family: Arial, Source Han Sans CN;
                  font-weight: 300;
                  color: rgba(102, 102, 102, 1);
                }
              }
            }
          }
        }
      }
    }
  }

  .english{

    .address {
      // height: 34rem;
    }
    .left{
      p{
        font-size: 1.8rem !important;
        letter-spacing: 0 !important;
        // padding-top: 3rem;
      }
      span{
        font-size: 0.88rem;
      }
    }
    .right{
      .menu{
        // max-width: 60rem !important;
        .item{
          // width: 20rem !important;
          p{
            font-size: 1.25rem !important;
          }
          span{
            text-align: left;
            // max-width: 90% !important;
            font-size: 0.88rem !important;
          }
        }
      }
    }
   .hidden-xs .address .content .left{
      width:25rem;
    }

  }
  .english{
     .visible-xs .address .content .left p{
      font-size: 1.2rem !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/contactus/LiveBoards.vue